'use strict';

import { isElement, forEach, debounce, uniqueId } from 'lodash';
import mustache from 'mustache';
import { addClass, removeClass } from '../../01-helpers/utilities/class';
import { get as getBookerOptions } from '../../01-helpers/utilities/options';
import { publish } from '../../01-helpers/event-manager';
import { getSessionStorage } from '../../01-helpers/session-manager';
import { CARD_ADDED, CARD_REMOVED } from '../../02-const/event-names';

const
	moduleName = 'card',

	selectors = {
		base: `.js-${moduleName}`,
		addTrigger: `.js-${moduleName}-add`,
		removeTrigger: `.js-${moduleName}-remove`,
		container: `.js-${moduleName}-container`,
		cardTemplate: '#cardTemplate',
		bookerOptions: 'Booker'
	},
	keys = {
		otherPlayers: 'OtherPlayers'
	};

export default class Card {

	constructor(baseElement) {
		if (!isElement(baseElement)) {
			console.error(`Element has not been found.`);
			return false;
		}

		this.baseElement = baseElement;
		this.container = this.baseElement.querySelector(selectors.container);
		this.addTriggers = this.baseElement.querySelectorAll(selectors.addTrigger);

		// get player localStorage if exists otherwise set maxCards to 4
		const filters = getSessionStorage('filters') || {};
		this.maxCards = filters.players || 4;

		this._bindEvents();

		this._setup();
	}

	/**
	 *	Bind event handling
	 **/
	_bindEvents() {
		forEach(this.addTriggers, addTrigger => {
			addTrigger.addEventListener('click', debounce(this._addCard.bind(this), 300, {'leading': true, 'trailing': false}));
		});

		this._bindRemoveTrigger();	
	}

	_bindRemoveTrigger() {
		const removeTriggers = this.baseElement.querySelectorAll(selectors.removeTrigger);
		forEach(removeTriggers, removeTrigger => {
			removeTrigger.removeEventListener('click', debounce(this._removeCard.bind(this), 300, { 'leading': true, 'trailing': false }));
			removeTrigger.addEventListener('click', debounce(this._removeCard.bind(this), 300, { 'leading': true, 'trailing': false }), {once: true});
		});	
	}

	_setup() {
		const booker = getBookerOptions(selectors.bookerOptions);
		const data = {
			number: 1,
			edit: 'edit'
		};

		if (booker) {
			data.url = booker.ImgUrl,
			data.name = booker.Firstname + " " + booker.Lastname,
			data.edit = '',
			data.disabled = 'disabled'
		}

		// if player filter is set to 1 remove the addCard button
		if( this.maxCards === "1" ) {
			this._disableButtons();
		}

	}

	_initCard(data) {
		const template = this.baseElement.querySelector(selectors.cardTemplate).innerHTML;

		return mustache.render(template, data);
	}

	/**
	 * Add a card to the container
	 * @param {any} evt
	 */
	_addCard(evt) {

		let totalCount = this.container.childElementCount;
		const id = `player__${uniqueId()}`;

		if (totalCount < this.maxCards) {
			// add empty card
			const data = {
				edit: 'edit',
				url: '/',
				id: id,
				number: totalCount + 1,
				name: ''
			},
				parsed = this._initCard(data);

			this.container.insertAdjacentHTML('beforeend', parsed);

			this._bindRemoveTrigger();
			totalCount++;
		}

		if (totalCount == this.maxCards) {
			// disable add button
			this._disableButtons();			
		}

		publish(CARD_ADDED, { 'id': id});
	}

	_disableButtons() {
		forEach(this.addTriggers, element => {
			element.disabled = true;
			addClass(element, 'hidden');
		});
	}

	/**
	 * Remove the card from the container
	 * @param {any} evt
	 */
	_removeCard(evt) {
		let totalCount = this.container.childElementCount;
		const trigger = evt.currentTarget,
			parent = trigger.parentElement;

		if (isElement(parent)) {
			publish(CARD_REMOVED, { parent: parent });
			parent.remove();
			totalCount--;
		}

		if (totalCount < this.maxCards) {
			// enable add button
			forEach(this.addTriggers, element => {
				element.disabled = false;
				removeClass(element, 'hidden');
			});			
		}

		//publish(CARD_ADDED);
	}
}

const initCard = () => {
	forEach(document.querySelectorAll(selectors.base), cardElement => {
		const card = new Card(cardElement);
	});
}

initCard();